import React, { useState, useRef, useEffect, CSSProperties } from "react";
import "./SimpleSelect.less";

type Option = {
   label: string;
   value: string;
};

type SimpleSelectProps = {
   style: CSSProperties;
   options: Option[];
   placeholder?: string;
   value?: Option | null;
   customSelectContainerClassName?: string;
   customSelectClassname?: string;
   onChange?: (value: Option) => void;
};

const SimpleSelect: React.FC<SimpleSelectProps> = ({
   style,
   options,
   placeholder = "Wybierz...",
   value,
   customSelectContainerClassName,
   customSelectClassname,
   onChange,
}) => {
   const [isOpen, setIsOpen] = useState(false);
   const [selected, setSelected] = useState<Option | null>(value ?? null);
   const [inputValue, setInputValue] = useState("");

   const containerRef = useRef<HTMLDivElement>(null);

   const handleOptionClick = (option: Option) => {
      setSelected(option);
      onChange?.(option);
      setIsOpen(false);
      setInputValue("");
   };

   const filteredOptions = options.filter((opt) =>
      opt.label.toLowerCase().startsWith(inputValue.toLowerCase()),
   );

   useEffect(() => {
      setSelected(null);
   }, [placeholder]);

   useEffect(() => {
      setSelected(value ?? null);
   }, [value]);

   useEffect(() => {
      const handleClickOutside = (event: MouseEvent) => {
         if (
            containerRef.current &&
            event.target instanceof Node &&
            !containerRef.current.contains(event.target)
         ) {
            setIsOpen(false);
         }
      };

      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
   }, []);

   return (
      <div
         ref={containerRef}
         className={`simple-custom-select-container ${customSelectContainerClassName || ""}`}
      >
         <div
            style={{ position: "relative", ...style }}
            className={`${customSelectClassname} select-display`}
            onClick={() => setIsOpen((prev) => !prev)}
         >
            <input
               className="select-input"
               placeholder={selected ? selected.label : placeholder}
               value={inputValue}
               onChange={(e) => setInputValue(e.target.value)}
            />
            <span className="material-symbols-outlined arrow">expand_more</span>
         </div>

         {isOpen && (
            <div className="select-dropdown">
               <ul className="select-options">
                  {filteredOptions.length > 0 ? (
                     filteredOptions.map((opt) => (
                        <li
                           key={opt.value}
                           className={`option-item ${
                              selected?.value === opt.value ? "selected" : ""
                           }`}
                           onClick={() => handleOptionClick(opt)}
                        >
                           {opt.label}
                        </li>
                     ))
                  ) : (
                     <li className="option-item disabled">Brak wyników</li>
                  )}
               </ul>
            </div>
         )}
      </div>
   );
};

export default SimpleSelect;
